import MemberDetail from './member_detail.vue'
import BalanceChange from './modules/balance_change.vue'
import SaleRecord from './modules/sale_record.vue'
import PointsRecord from './modules/points_record.vue'

export default {
    name: 'memberDetail',
    path: 'memberDetail',
    component: MemberDetail,
    children: [
        {
            path: '',
            redirect: 'balanceChange'
        },
        {
            path: 'balanceChange',
            component: BalanceChange
        },
        {
            path: 'saleRecord',
            component: SaleRecord
        }, {
            path: 'pointsRecord',
            component: PointsRecord
        }
    ]
}
